<div class="modal-header">
    <h5 class="modal-title">Bakiye Güncelle</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="col-12">
            <label class="form-label">Yeni Bakiye</label>
            <input type="number" class="form-control" formControlName="balance" />
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control" formControlName="description"></textarea>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose(false)">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Kaydet</button>
</div>